class TreesDirectHeader extends HTMLElement {
  constructor() {
    super();

    this.siteHeader = this.querySelector('[data-site-header]');
    this.announcementBar = this.querySelector('[data-announcement-bar]');
    this.cartCounts = document.querySelectorAll('[data-cart-count]');

    this.scrollController = new window.HeaderScrollController(this);
    this.menuController = new window.HeaderMenuController(this);
    this.searchController = new window.HeaderSearchController(this);

    this.handleResize = this.handleResize.bind(this);
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.setDrawerOffset();

    this.scrollController.connect();
    this.menuController.connect();
    this.searchController.connect();

    window.addEventListener('resize', this.handleResize);
    document.addEventListener('cart:updated', this.handleCartUpdate);
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.scrollController.disconnect();
    this.menuController.disconnect();
    this.searchController.disconnect();

    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('cart:updated', this.handleCartUpdate);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  handleCartUpdate(event) {
    const itemCount = Number(event.detail?.itemCount || 0);

    this.cartCounts.forEach((cartCount) => {
      cartCount.textContent = itemCount;
      cartCount.hidden = itemCount === 0;
    });
  }

  handleKeydown(event) {
    if (event.key !== 'Escape') return;

    if (this.searchController.isOpen()) {
      this.searchController.close({ returnFocus: true });
      return;
    }

    this.menuController.close();
  }

  handleResize() {
    this.setDrawerOffset();

    if (window.innerWidth > 1100) {
      this.menuController.close();
      this.searchController.close();
    }
  }

  setDrawerOffset() {
    const announcementHeight = this.announcementBar?.offsetHeight || 0;
    const headerHeight = this.siteHeader?.offsetHeight || 0;
    const drawerTop = announcementHeight + headerHeight;

    document.documentElement.style.setProperty('--mobile-drawer-top', `${drawerTop}px`);
  }
}

if (!customElements.get('trees-direct-header')) {
  customElements.define('trees-direct-header', TreesDirectHeader);
}
